/**
 * Tests if the passed value is a string path.
 * @param val The value to check.
 */
export default (val: unknown): val is string =>
  typeof val === 'string' && /^[a-zA-Z0-9_]*\.-?[0-9]+$/.test(val);
